<template>
  <div>
    <div  v-if="isScrolled9">
      <Header1/>
    </div>
    <div style="height: 5em;"></div>
    <!-- info-banner -->

    <div class="info-banner order-banner">

      <div class="img"><img src="https://www.yasubit.com/template/pc/skin/images/banner-order.png" alt=""></div>

      <div class="tbox">

        <div class="timg"><img src="https://www.yasubit.com/template/pc/skin/images/img22.png" alt=""> </div>

        <div class="ttbox">

          <h2 class="t1">订单提交成功！请尽快完成付款</h2>

          <div class="t2">请在48小时内完成支付，否则订单将会自动取消</div>

        </div>

      </div>

    </div>



    <!-- 提交订单 -->

    <div class="order">

      <div class="box">

        <div class="box1">

          <h3 class="t1">订单信息</h3>

          <div class="t2">

            订单号：{{ orderMsg1 }}
            <br>

            PRO套餐：<span>{{ orderMsg2 }}</span>

            <br>

            支付金额：¥ {{ orderMsg3 }}.00
          </div>

        </div>

        <div class="box2">

          <h3 class="t1">支付方式</h3>

          <div  class="tips ">
            <!--         未读-->
            <span @click="weatherRead" v-if="!isRead">
            <img src="https://www.yasubit.com/template/pc/skin/images/icon38.png" alt=""><img src="https://www.yasubit.com/template/pc/skin/images/icon38-1.png" alt="">
            </span>
      <!--      已读-->
            <span @click="weatherRead"   v-if="isRead" >
           <img src="https://www.yasubit.com/template/pc/skin/images/icon38-1.png" alt="">
            </span>
            我已阅读并接受
            <span @click="goUseragreement"><a >用户协议</a></span>
            和
           <span @click="goPrivacy"> <a >隐私政策</a></span>
          </div>





          <div class="payway">




            <li :class="{ 'way': true, 'on': isSelected1 }" @click="toggleSelection(1)">

              <a  class="block cover pay-online" href="JavaScript:void(0);" data-id="1" data-mark="wechat">

                <img src="https://www.yasubit.com/template/pc/users/skin/images/wechat.png" class="img-fluid inline-block" style="width: 163px; height: 52px;">

              </a>

            </li>



            <li :class="{ 'way': true, 'on': isSelected2 }" @click="toggleSelection(2)">

              <a class="block cover pay-online" href="JavaScript:void(0);" data-id="2" data-mark="alipay">

                <img src="https://www.yasubit.com/template/pc/users/skin/images/alipay.png" class="img-fluid inline-block" style="width: 163px; height: 52px;">

              </a>

            </li>



            <div :class="{ 'way': true, 'on': isSelected3 }" @click="toggleSelection(3)">
              <a data-src="/user/Pay/paypal/id/4766.html" href="JavaScript:void(0);"><img src="https://www.yasubit.com/template/pc/skin/images/icon42.png" alt="">Paypal</a>
            </div>

          </div>

        </div>



        <div class="next">

          <div @click="gopay" class="gopay">去支付</div>

          <a href="/" class="back">返回首页</a>


<!--                    <div style="background-color: pink;height: 300px;width: 300px">-->
<!--                     <div id="qqq">-->
<!--                      <div id="qrCode" ref="qrCodeDiv"></div>-->
<!--                     </div>-->
<!--                    </div>-->


        </div>

      </div>

    </div>

    <el-dialog
        title="微信扫码支付"
        :visible.sync="dialogVisible"
        width=350px
        :before-close="handleClose">
                <div style="">
                 <div id="qqq">
                  <div id="qrCode" ref="qrCodeDiv"></div>
                 </div>
                </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="Cancel">取 消</el-button>
    <el-button type="primary" @click="Cancel">确 定</el-button>
  </span>
    </el-dialog>




    <Footer/>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import Header from "@/views/header.vue";
import Banner from "../components/Banner";
import Footer from "@/views/footer.vue";
import Header1 from "@/views/header1.vue";
import LoginDialog from "./loginFront.vue";
import Cookies from "js-cookie";
import axios from "axios";
export default {
  components: {

    Header1,
    Header,
    Banner,
    Footer,
    LoginDialog,
  },
  data() {

    return {
      timerId: null, // 用于存储定时器的 ID
      dialogVisible: false,
      orderMsg1:"",
      orderMsg2:"",
      orderMsg3:"",

      url: '',
      isSelected1: false,
      isSelected2: false,
      isSelected3: false,
      isRead:false,
      casePrice:0,
      caseTime:"",
      totalPerson:0,
      usersPrice:0,
      discount:0,
      price:0,
      memberList:[],
      typeList:[],
      token:"",
      showTeamPrice:false,
      isTeam:false,
      containerHeight: 'auto',
      personShow:false,
      personShow1:false,
      personShow2:false,
      personShow3:false,
      member:"请选择团队成员数",
      time:"请选择会员时长",
      case1:"请选择套餐",
      options: [],
      value: '',
      isScrolled9: true,
      name:'',
      aid:0,
      text: '',
      textarea: '',
      loading: true,
      caseList: []
    };
  },
  mounted() {

    window.scrollTo(0, 0);
    this.token=localStorage.getItem("loginToken")
    this.orderMsg1= sessionStorage.getItem('orderMsg1')
    this.orderMsg2= sessionStorage.getItem('orderMsg2')
    this.orderMsg3= sessionStorage.getItem('orderMsg3')



    window.addEventListener('scroll', this.handleScroll9);
    // window.console.log("case");
    this.$http
        .get("Cases/GetCasesAll")
        .then(response => {
          //console.log(response);
          this.caseList = response.data;
          //window.console.log(this.caseList);
          this.loading = false;
        })
        .catch(function(error) {
          window.console.log(error);
        });

    // this.redirectToWeixinLogin();
    // this. getData()

  },
  beforeDestroy() {
    // 在组件销毁之前清理定时器
    clearInterval(this.timerId);
  },
  methods:{
//关闭弹窗
    Cancel(){

      this.dialogVisible = false
      //停止定时器
      clearInterval(this.timerId);

    },
    //跳回首页
    goIndex(){
      this.$router.push({path:"/"})
    },

    //监测测支付状态
    getPayStatus() {
      const orderCode = this.orderMsg1;
      const token = this.token;
      // 构建请求路径
      const url = `/yasubit/pay/getPayStatus?orderCode=${orderCode}`;
      // 使用 Axios 发起 GET 请求
      axios.get(url, {
        headers: {
          Authorization: token,
        },
      })
          .then(response => {
            console.log("支付状态")
            // 根据需要处理响应
            console.log(response.data.msg)
            if(response.data.msg==="true"){
              //停止定时器
              clearInterval(this.timerId);
              this.$message.success("支付成功，即将在3秒后跳回首页")
              this.dialogVisible=false
              setTimeout(() => {
                this.goIndex();
              }, 3000);

            }

          })
          .catch(error => {
            // 处理错误
            console.error(error);
          });
    },

    //控制弹窗
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
    },

    redirectToWeixinLogin() {
      const orderCode = this.orderMsg1;
      const token = this.token;
      // 构建请求路径
      const url = `http://192.168.10.187:8080/yasubit/pay/aliPay?orderCode=${orderCode}`;
      // 使用 Axios 发起 GET 请求
      axios.get(url, {
        headers: {
          Authorization: token,
        },
      })
          .then(response => {
            // 根据需要处理响应
            console.log(response.data)
            let o = document.getElementById("alipayFrame")
            let ed = document.getElementById ? o.contentWindow.document : o.contentDocument
            ed.open()
            ed.write(response.data) // 放入支付宝的表单数据
            ed.close()
            ed.contentEditable = true
            ed.designMode = 'on'
          })
          .catch(error => {
            // 处理错误
            console.error(error);
          });
    },
    gopay(){

      if (this.isRead) {
        if (this.isSelected2 === true) {

          // 跳转到支付宝页面进行支付
          this.$router.push({ path: 'alipay' });
          sessionStorage.setItem('orderCode', this.orderMsg1);





          //进入iframe进行支付
          // this.$router.push({ path: 'alipay' });
          // sessionStorage.setItem('orderCode', this.orderMsg1);





        } else if (this.isSelected1 === true) {
          console.log('微信支付');



          const orderCode = this.orderMsg1;
          const token = this.token;
          // 构建请求路径
          const url = `/yasubit/shop_order/pay/${orderCode}`;
          // 使用 Axios 发起 GET 请求
          axios.get(url, {
            headers: {
              Authorization: token,
            },
          })
              .then(response => {
               this.url=response.data.msg
                this.generateQRCode();
                this.dialogVisible=true

                //监测支付状态进行轮询
                this.timerId= setInterval(() => {
                  this.getPayStatus();
                }, 2000);

                // 设置超过18秒后停止定时器
                setTimeout(() => {
                  clearInterval(this.timerId);
                  console.log("超过半小时，停止定时器");
                }, 1800000);




              })
              .catch(error => {
                // 处理错误
                console.error(error);
              });













        } else {
          this.$message.warning("请选择支付方式！");
        }
      } else {
        this.$message.warning("请先勾选用户协议！");
      }




    },

    bindQRCode: function () {

      // 使用 $nextTick 来确保在下一个 DOM 更新周期执行
      this.$nextTick(() => {
        // 清空 qrCodeDiv 元素内容
        this.$refs.qrCodeDiv.innerHTML = '';

        // 获取屏幕宽度
        const screenWidth = window.innerWidth;
        // 设置容器的宽度和高度为屏幕宽度的30%
        this.$refs.qrCodeDiv.style.width = screenWidth * 0.1 + 'px';
        this.$refs.qrCodeDiv.style.height = screenWidth * 0.1 + 'px';

        // 生成新的二维码
        new QRCode(this.$refs.qrCodeDiv, {
          text: this.url,
          width: screenWidth * 0.1,
          height: screenWidth * 0.1,
          colorDark: "#333333",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.L
        });
      });
    },

    generateQRCode () {


      this.$nextTick(function () {
        this.bindQRCode();
      })
    },


    weatherRead(){
      this.isRead=!this.isRead
    },
    toggleSelection(index) {
      //已读用户协议和隐私条款
      if(this.isRead){

        if(index===1){
          this.isSelected1 = !this.isSelected1;
          this.isSelected2 = false;
          this.isSelected3 = false;
        }
        if(index===2){
          this.isSelected1 = false;
          this.isSelected2 = !this.isSelected2;
          this.isSelected3 = false;
        }
        if(index===3){
          this.isSelected1 = false;
          this.isSelected2 = false;
          this.isSelected3 = !this.isSelected3;

        }


        }else {
//未读用户协议和隐私条款
        this.$message.warning("请先勾选用户协议！")


      }


    },
    openLoginDialog() {
      // console.log('Opening login dialog');

      this.$refs.loginDialog.showLoginDialog();

    },
    updateUser(newUser) {
      const userData = JSON.stringify(newUser);
      Cookies.set("user", userData, { expires: 30 });
      this.user = newUser;
      this.isLogin = true;
    },
    perChase(){

      this.token=localStorage.getItem("loginToken")
      // console.log(JSON.parse(localStorage.getItem("loginStatus")));
      // 从localStorage中获取保存的数据
      if(JSON.parse(localStorage.getItem("loginStatus"))){
        //已登录
        // console.log("已登陆成功")
      }else {
//未登录
//         console.log("未登陆成功")
        this.openLoginDialog()
      }



    },
    goUseragreement(){

      this.$router.push({path:"useragreement"})
    },
    goPrivacy(){

      this.$router.push({path:"privacy"})
    },
    getData() {
      // console.log(this.token)

      this.token = "Bearer " + this.token; // 添加空格
      // 定义请求头，替换 'YourAuthToken' 为你的有效身份验证令牌
      const headers = {"Authorization": this.token};

      // 构建请求参数
      const data = { productId: this.aid, productType: "1" };

      // 发送 POST 请求并在请求中添加自定义请求头
      this.$http.post('/yasubit/shop_order', data, { headers })
          .then(response => {
            // console.log(response.data.data)
            this.orderMsg1=response.data.data.orderCode
            this.orderMsg2=response.data.data.productName
            this.orderMsg3=response.data.data.orderTotalAmount
          })
          .catch(error => {
            // 请求失败时处理错误
            console.error('Error fetching data:', error);
          });
    },



    Persion1(){
      this.isTeam=false
    },
    Persion2(){
this.isTeam=true
    },
    toggleDropdown() {
      this.personShow = !this.personShow;
    },
    toggleDropdown2() {
      this.personShow2 = !this.personShow2;
    },
    toggleDropdown3() {
      this.personShow3 = !this.personShow3;
    },
// 取出数字参数
   extractNumberFromString(inputString) {
  const match = inputString.match(/\d+/);

  if (match) {
    return parseInt(match[0], 10);
  } else {
    return null; // 或者可以返回其他默认值或进行其他处理
  }
},

    selectMember(m) {
      this.member = m.title
      this.discount=m.discount
      this.totalPerson= this.extractNumberFromString(m.title)
      // console.log( this.totalPerson)
      this.toggleDropdown(); // 选择后关闭下拉
      if(this.member!=="请选择团队成员数"&&this.time!=="请选择会员时长"&&this.case1!=="请选择套餐"){

        this.price= Math.ceil(this.totalPerson*this.usersPrice*this.discount)


        this.showTeamPrice=true

      }
    },
    selectMember2(m) {
      // console.log(m)
      this.time = m.title;

      this.usersPrice=m.usersPrice
      this.toggleDropdown2(); // 选择后关闭下拉
      if(this.member!=="请选择团队成员数"&&this.time!=="请选择会员时长"&&this.case1!=="请选择套餐"){
        this.price= Math.ceil(this.totalPerson*this.usersPrice*this.discount)
        this.showTeamPrice=true
      }
    },
    selectMember3() {
      this.case1 =  "视频图片压缩";
      this.toggleDropdown3(); // 选择后关闭下拉
      if(this.member!=="请选择团队成员数"&&this.time!=="请选择会员时长"&&this.case1!=="请选择套餐"){
        this.price= Math.ceil(this.totalPerson*this.usersPrice*this.discount)
        this.showTeamPrice=true
      }
    },
    open(){
      if (this.personShow) {
        this.personShow = false;
        this.containerHeight = '0'; // 隐藏时高度设为0
      } else {
        this.personShow = true;
        this.containerHeight = 'auto'; // 显示时高度设为auto或者其他适当的值
      }

    },
    open2(){
      if (this.personShow2) {
        this.personShow2 = false;
        this.containerHeight = '0'; // 隐藏时高度设为0
      } else {
        this.personShow2 = true;
        this.containerHeight = 'auto'; // 显示时高度设为auto或者其他适当的值
      }

    },
    open3(){
      if (this.personShow3) {
        this.personShow3 = false;
        this.containerHeight = '0'; // 隐藏时高度设为0
      } else {
        this.personShow3 = true;
        this.containerHeight = 'auto'; // 显示时高度设为auto或者其他适当的值
      }

    },
    handleScroll9() {
      // 获取当前滚动位置
      const scrollY = window.scrollY || window.pageYOffset;

      // 可以设置一个阈值来确定何时改变isScrolled9的值
      const dis = 100;

      // 判断滚动位置是否大于阈值
      if (scrollY > dis) {
        // 向下滚动，将isScrolled9设为false
        this.isScrolled9 = false;
      } else {
        // 向上滚动，将isScrolled9设为true
        this.isScrolled9 = true;
      }
      // const scrollDistance = window.scrollY || document.documentElement.scrollTop;
      // // 当滚动距离小于等于200px时，设置isScrolled9为true
      // this.isScrolled9 = scrollDistance <=500;

    },
    submit(){
      // console.log("内容")

      // Get the input element by its ID
      let a = document.getElementById('usernameInput');
      let b = document.getElementById('usercontactInput');
      let c = document.getElementById('usercontactInput1');
      let d = document.getElementById('usercontactInput2');

      // console.log(a)

      // Get the value entered by the user
      let username = a.value;
      let userPhone = b.value;
      let userEmail = c.value;
      let userIdea = d.value;

      if(username.trim() !== ''&&userPhone.trim() !== ''&&userEmail.trim() !== ''&&userIdea.trim() !== ''){

        const headers =
            {
              'Authorization': '',

            };
        // 定义请求体，替换 'yourPayloadData' 为实际的请求体数据
        const postData = {
          17:username,
          19:userPhone,
          21:userEmail,
          23:userIdea,
          typeid: 67,
        };
        // 发送 POST 请求并在请求中添加自定义请求头
        this.$http.post('yasubit/guestbook/insert', postData, { headers })
            .then(response => {
              // 请求成功时更新数据
              // console.log("post成功");
              this.$message.success("提交成功")
              a.value = '';
              b.value = '';
              c.value = '';
              d.value = '';

              // this.data = response.data;
            })
            .catch(error => {
              // 请求失败时处理错误
              console.error('Error fetching data:', error);
            });

      }else {

        this.$message.warning("需填写完整信息")
      }









      this.$http.post('yasubit/guestbook/insert', data)
          .then(response => {
            this.$message.success(response.data.msg);
          })
          .catch(error => {
            this.$message.error(error);
          });
    }
  }
};
</script>

<style>

#qqq {
  background-color:#ffffff ;
  width:300px;
  height:300px;
display: flex;
  justify-content: center;
  align-items: center;
}

.person{
  color:  #9fa19f;
  padding: 10px;
  width: 100%;height:40px; display: flex;justify-content: center;align-items: center;
  cursor: pointer; /* 当鼠标悬停在元素上时显示手型光标 */
}
.person:hover {
  background-color: #a3d0fb; /* 鼠标悬停时的背景颜色 */
}
.person-container {
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.04);
  transition: height 1s ease-in-out; /* 添加过渡效果 */
  overflow: hidden; /* 隐藏溢出部分 */
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>